import FJTextStyle from './FJTextStyle';
import FJUnderline from './FJUnderline';

class FJTextStyleUnderline extends FJTextStyle {
    initStyles(props = {}) {
        let textUnderline = new FJUnderline({
            ...props,
            position: 'relative',
            offset: 50,
            width: 30,
            color: '#ffffff',
        });
        this._styles = [textUnderline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{offset: *}}
     */
    getAdjustInfo() {
        let underline = this._styles[0];
        return {
            color: [underline.color],
            width: underline.width,
            offset: underline.offset,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        if (info.color[0] !== '') this._styles[0].color = info.color[0];
        if (info.offset !== '') this._styles[0].offset = info.offset;
        if (info.width !== '') this._styles[0].width = info.width;
    }
}

export default FJTextStyleUnderline;
